<template>
  <div class="no-permission">
    <div class="no-permission-content">
      <div class="icon-wrapper">
        <i class="el-icon-lock"></i>
      </div>
      <h3>暂无访问权限</h3>
      <p>您还没有被分配任何访问权限，请联系管理员为您分配。</p>
      <el-button type="primary" @click="goBack">
        <i class="el-icon-arrow-left"></i> 返回登录
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'no-permission',
  methods: {
    goBack() {
      this.$router.push({ name: 'login' })
    }
  }
}
</script>

<style lang="scss" scoped>
.no-permission {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background: #f5f7fa;

  .no-permission-content {
    text-align: center;
    padding: 40px;
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    max-width: 400px;

    .icon-wrapper {
      width: 80px;
      height: 80px;
      border-radius: 50%;
      background: linear-gradient(135deg, #f5f7fa 0%, #e8eef5 100%);
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto 20px;

      i {
        font-size: 36px;
        color: #909399;
      }
    }

    h3 {
      font-size: 20px;
      color: #303133;
      margin: 0 0 8px;
    }

    p {
      font-size: 14px;
      color: #909399;
      margin: 0 0 24px;
      line-height: 1.6;
    }

    .el-button {
      border-radius: 8px;
      padding: 10px 28px;

      i {
        margin-right: 4px;
      }
    }
  }
}
</style>
